<template>
  <div class="bri-wrapper">
    <SectionLanding />

    <SectionBeltRoad />

    <SectionWhyChina />

    <SectionFinanceD3 />

    <SectionDiplomacy />

    <SectionIssues />

    <SectionFinal />

    <SectionFootnotes />

    <SectionPostLists />

    <SectionBooklet />
  </div>
</template>

<script>
// components
import SectionLanding from '@/components/views/SectionLanding.vue';
import SectionBeltRoad from '@/components/views/SectionBeltRoad.vue';
import SectionWhyChina from '@/components/views/SectionWhyChina.vue';
import SectionFinanceD3 from '@/components/views/SectionFinanceD3.vue';
import SectionDiplomacy from '@/components/views/SectionDiplomacy.vue';
import SectionIssues from '@/components/views/SectionIssues.vue';
import SectionFinal from '@/components/views/SectionFinal.vue';
import SectionFootnotes from '@/components/views/SectionFootnotes.vue';
import SectionPostLists from '@/components/views/SectionPostLists.vue';
import SectionBooklet from '@/components/views/SectionBooklet.vue';

export default {
  name: 'TheContent',
  components: {
    SectionLanding,
    SectionBeltRoad,
    SectionWhyChina,
    SectionFinanceD3,
    SectionDiplomacy,
    SectionIssues,
    SectionFinal,
    SectionFootnotes,
    SectionPostLists,
    SectionBooklet,
  },
  mounted() {
    // load FB SDK
    this.$FB.load();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bri-wrapper {
  height: 100%;
}
</style>
